// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1pd2E","right":"styles_right__3YX_Q"};